import React, { Component } from 'react';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
import TooltipTarget from '../tooltip/TooltipTarget';

class VxBasicSelectField extends Component {
	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		options: PropTypes.array,
		tooltipContent: PropTypes.string,
		tooltipId: PropTypes.string,
		tooltipPlacement: PropTypes.string
	}

	render() {
		const {
			input,
			label,
			meta: { touched, error },
			id
		} = this.props;

		const hasError = touched && error;

		return (
			<div className={`vx_form-group ${hasError ? 'vx_has-error' : ''}`}>
				<label htmlFor={id}>{label}
					{this.props.tooltipContent &&
						<TooltipTarget content={this.props.tooltipContent}
							id={this.props.tooltipId}
							placement={this.props.tooltipPlacement}>
						</TooltipTarget>
					}
				</label>
				<div className="vx_select">
					<select
						className="form-control vx_form-control custom-margin-top-2"
						{...input}
						id={id}
						aria-label={label}
					>
						{
							_map(this.props.options, (option) => {
								return (
									<option
										key={option.value}
										value={option.value}
										aria-label={option.displayValue}
										name={option.value}
									>
										{option.displayValue}
									</option>
								)
							})
						}
					</select>
					<span className="vx_selectIcon_error"></span>
				</div>
			</div>
		)
	}
}

export default VxBasicSelectField;



// WEBPACK FOOTER //
// ./buttons/components/vxFields/VxBasicSelectField.js